/**
 * feature-config flag names owned by site-discovery
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const SITE_DISCOVERY_FLAG_NAMES = {
  AEO_SITE_AUDIT: 'ff-aeo-24-centralized-control-center',
  AEO_CONTENT_AUTHORING_WORKFLOWS: 'ff-aeo-251-content-authoring',
  AEO_AGENT_INSTRUCTIONS_FOR_CONTENT_RECOMMENDATIONS:
    'ff-aeo-1563-agent-instructions-for-content-recommendations',
  AEO_BRAND: 'ff-aeo-172-brand',
  AEO_RECOMMENDATION_FEEDBACK: 'ff-aeo-1325-recommendation-feedback',
  DEFAULT_GLOBAL_CANONICAL_TAG: 'ff-sd-default-global-canonical',
  CANONICAL_PAGINATION_PARAMS_SETTING:
    'ff-cont-5982-pagination-params-in-canon-links-setting',
  LLMS_TXT: 'ff-sd-95-llms-txt',
  HREFLANG_CANONICAL_TAG_UPDATES: 'ff-sd-212-hreflang-updates',
  SITEMAP_CONTROLS_ENTITLEMENT_GATING:
    'ff-sd-393-sitemap-controls-entitlement-gating',
  LOCALE_AWARE_SITEMAP_GEN: 'ff-sd-391-locale-aware-sitemap-gen',
  SITEMAP_INDEX_API: 'ff-proj-aeo-18-sitemap-index-api',
  SITEMAP_PURGE_AFTER_FULL_PUBLISH:
    'ff-aeo-1435-sitemap-purge-after-full-publish',
} as const;
